export default "__VITE_ASSET__BdMHUNgq__"